webpackJsonp([35783957827783],{

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eventOptionsKey = __webpack_require__(60);
	
	var _eventOptionsKey2 = _interopRequireDefault(_eventOptionsKey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function ensureCanMutateNextEventHandlers(eventHandlers) {
	  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
	    // eslint-disable-next-line no-param-reassign
	    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
	  }
	}
	
	var TargetEventHandlers = function () {
	  function TargetEventHandlers(target) {
	    _classCallCheck(this, TargetEventHandlers);
	
	    this.target = target;
	    this.events = {};
	  }
	
	  _createClass(TargetEventHandlers, [{
	    key: 'getEventHandlers',
	    value: function () {
	      function getEventHandlers(eventName, options) {
	        var key = String(eventName) + ' ' + String((0, _eventOptionsKey2['default'])(options));
	
	        if (!this.events[key]) {
	          this.events[key] = {
	            handlers: [],
	            handleEvent: undefined
	          };
	          this.events[key].nextHandlers = this.events[key].handlers;
	        }
	
	        return this.events[key];
	      }
	
	      return getEventHandlers;
	    }()
	  }, {
	    key: 'handleEvent',
	    value: function () {
	      function handleEvent(eventName, options, event) {
	        var eventHandlers = this.getEventHandlers(eventName, options);
	        eventHandlers.handlers = eventHandlers.nextHandlers;
	        eventHandlers.handlers.forEach(function (handler) {
	          if (handler) {
	            // We need to check for presence here because a handler function may
	            // cause later handlers to get removed. This can happen if you for
	            // instance have a waypoint that unmounts another waypoint as part of an
	            // onEnter/onLeave handler.
	            handler(event);
	          }
	        });
	      }
	
	      return handleEvent;
	    }()
	  }, {
	    key: 'add',
	    value: function () {
	      function add(eventName, listener, options) {
	        var _this = this;
	
	        // options has already been normalized at this point.
	        var eventHandlers = this.getEventHandlers(eventName, options);
	
	        ensureCanMutateNextEventHandlers(eventHandlers);
	
	        if (eventHandlers.nextHandlers.length === 0) {
	          eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
	
	          this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
	        }
	
	        eventHandlers.nextHandlers.push(listener);
	
	        var isSubscribed = true;
	        var unsubscribe = function () {
	          function unsubscribe() {
	            if (!isSubscribed) {
	              return;
	            }
	
	            isSubscribed = false;
	
	            ensureCanMutateNextEventHandlers(eventHandlers);
	            var index = eventHandlers.nextHandlers.indexOf(listener);
	            eventHandlers.nextHandlers.splice(index, 1);
	
	            if (eventHandlers.nextHandlers.length === 0) {
	              // All event handlers have been removed, so we want to remove the event
	              // listener from the target node.
	
	              if (_this.target) {
	                // There can be a race condition where the target may no longer exist
	                // when this function is called, e.g. when a React component is
	                // unmounting. Guarding against this prevents the following error:
	                //
	                //   Cannot read property 'removeEventListener' of undefined
	                _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
	              }
	
	              eventHandlers.handleEvent = undefined;
	            }
	          }
	
	          return unsubscribe;
	        }();
	        return unsubscribe;
	      }
	
	      return add;
	    }()
	  }]);
	
	  return TargetEventHandlers;
	}();
	
	exports['default'] = TargetEventHandlers;

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports['default'] = CAN_USE_DOM;

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = canUsePassiveEventListeners;
	
	var _canUseDOM = __webpack_require__(58);
	
	var _canUseDOM2 = _interopRequireDefault(_canUseDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Adapted from Modernizr
	// https://github.com/Modernizr/Modernizr/blob/5eea7e2a/feature-detects/dom/passiveeventlisteners.js#L26-L35
	function testPassiveEventListeners() {
	  if (!_canUseDOM2['default']) {
	    return false;
	  }
	
	  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
	    return false;
	  }
	
	  var supportsPassiveOption = false;
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function () {
	        function get() {
	          supportsPassiveOption = true;
	        }
	
	        return get;
	      }()
	    });
	    window.addEventListener('test', null, opts);
	  } catch (e) {
	    // do nothing
	  }
	
	  return supportsPassiveOption;
	}
	
	var memoized = void 0;
	
	function canUsePassiveEventListeners() {
	  if (memoized === undefined) {
	    memoized = testPassiveEventListeners();
	  }
	  return memoized;
	}

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = eventOptionsKey;
	/* eslint-disable no-bitwise */
	
	/**
	 * Generate a unique key for any set of event options
	 */
	function eventOptionsKey(normalizedEventOptions) {
	  if (!normalizedEventOptions) {
	    return 0;
	  }
	
	  // If the browser does not support passive event listeners, the normalized
	  // event options will be a boolean.
	  if (normalizedEventOptions === true) {
	    return 100;
	  }
	
	  // At this point, the browser supports passive event listeners, so we expect
	  // the event options to be an object with possible properties of capture,
	  // passive, and once.
	  //
	  // We want to consistently return the same value, regardless of the order of
	  // these properties, so let's use binary maths to assign each property to a
	  // bit, and then add those together (with an offset to account for the
	  // booleans at the beginning of this function).
	  var capture = normalizedEventOptions.capture << 0;
	  var passive = normalizedEventOptions.passive << 1;
	  var once = normalizedEventOptions.once << 2;
	  return capture + passive + once;
	}

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EVENT_HANDLERS_KEY = undefined;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	
	var _normalizeEventOptions = __webpack_require__(62);
	
	var _normalizeEventOptions2 = _interopRequireDefault(_normalizeEventOptions);
	
	var _TargetEventHandlers = __webpack_require__(57);
	
	var _TargetEventHandlers2 = _interopRequireDefault(_TargetEventHandlers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Export to make testing possible.
	var EVENT_HANDLERS_KEY = exports.EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';
	
	function addEventListener(target, eventName, listener, options) {
	  if (!target[EVENT_HANDLERS_KEY]) {
	    // eslint-disable-next-line no-param-reassign
	    target[EVENT_HANDLERS_KEY] = new _TargetEventHandlers2['default'](target);
	  }
	  var normalizedEventOptions = (0, _normalizeEventOptions2['default'])(options);
	  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
	}
	
	// Deprecated
	function removeEventListener(unsubscribeFn) {
	  unsubscribeFn();
	}

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = normalizeEventOptions;
	
	var _canUsePassiveEventListeners = __webpack_require__(59);
	
	var _canUsePassiveEventListeners2 = _interopRequireDefault(_canUsePassiveEventListeners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function normalizeEventOptions(eventOptions) {
	  if (!eventOptions) {
	    return undefined;
	  }
	
	  if (!(0, _canUsePassiveEventListeners2['default'])()) {
	    // If the browser does not support the passive option, then it is expecting
	    // a boolean for the options argument to specify whether it should use
	    // capture or not. In more modern browsers, this is passed via the `capture`
	    // option, so let's just hoist that value up.
	    return !!eventOptions.capture;
	  }
	
	  return eventOptions;
	}

/***/ }),

/***/ 824:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(2));
	var consolidatedEvents = __webpack_require__(61);
	var PropTypes = _interopDefault(__webpack_require__(8));
	
	/**
	 * Attempts to parse the offset provided as a prop as a percentage. For
	 * instance, if the component has been provided with the string "20%" as
	 * a value of one of the offset props. If the value matches, then it returns
	 * a numeric version of the prop. For instance, "20%" would become `0.2`.
	 * If `str` isn't a percentage, then `undefined` will be returned.
	 *
	 * @param {string} str The value of an offset prop to be converted to a
	 *   number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was not a percentage.
	 */
	function parseOffsetAsPercentage(str) {
	  if (str.slice(-1) === '%') {
	    return parseFloat(str.slice(0, -1)) / 100;
	  }
	}
	
	/**
	 * Attempts to parse the offset provided as a prop as a pixel value. If
	 * parsing fails, then `undefined` is returned. Three examples of values that
	 * will be successfully parsed are:
	 * `20`
	 * "20px"
	 * "20"
	 *
	 * @param {string|number} str A string of the form "{number}" or "{number}px",
	 *   or just a number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was neither a number nor string ending in "px".
	 */
	function parseOffsetAsPixels(str) {
	  if (!isNaN(parseFloat(str)) && isFinite(str)) {
	    return parseFloat(str);
	  } else if (str.slice(-2) === 'px') {
	    return parseFloat(str.slice(0, -2));
	  }
	}
	
	/**
	 * @param {string|number} offset
	 * @param {number} contextHeight
	 * @return {number} A number representing `offset` converted into pixels.
	 */
	function computeOffsetPixels(offset, contextHeight) {
	  var pixelOffset = parseOffsetAsPixels(offset);
	
	  if (typeof pixelOffset === 'number') {
	    return pixelOffset;
	  }
	
	  var percentOffset = parseOffsetAsPercentage(offset);
	  if (typeof percentOffset === 'number') {
	    return percentOffset * contextHeight;
	  }
	}
	
	var constants = {
	  above: 'above',
	  inside: 'inside',
	  below: 'below',
	  invisible: 'invisible'
	};
	
	function debugLog() {
	  if (false) {
	    console.log(arguments); // eslint-disable-line no-console
	  }
	}
	
	var errorMessage = '<Waypoint> expected to receive a single React element child.\n\n' + 'See https://goo.gl/LrBNgw for more info.';
	
	/**
	 * Raise an error if more that one child was provided to "children"
	 *
	 * @param {?React.element} children
	 * @return {undefined}
	 */
	function ensureChildrenIsValid(children) {
	  if (children) {
	    try {
	      React.Children.only(children);
	    } catch (e) {
	      throw new Error(errorMessage);
	    }
	  }
	}
	
	/**
	 * When an element's type is a string, it represents a DOM node with that tag name
	 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
	 *
	 * @param {React.element} Component
	 * @return {bool} Whether the component is a DOM Element
	 */
	function isDOMElement(Component) {
	  return typeof Component.type === 'string';
	}
	
	var errorMessage$1 = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';
	
	/**
	 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
	 *
	 * @param {?React.element} children
	 * @param {?HTMLElement} ref
	 * @return {undefined}
	 */
	function ensureRefIsProvidedByChild(children, ref) {
	  if (children && !isDOMElement(children) && !ref) {
	    throw new Error(errorMessage$1);
	  }
	}
	
	/**
	 * @param {object} bounds An object with bounds data for the waypoint and
	 *   scrollable parent
	 * @return {string} The current position of the waypoint in relation to the
	 *   visible portion of the scrollable parent. One of `constants.above`,
	 *   `constants.below`, or `constants.inside`.
	 */
	function getCurrentPosition(bounds) {
	  if (bounds.viewportBottom - bounds.viewportTop === 0) {
	    return constants.invisible;
	  }
	
	  // top is within the viewport
	  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
	    return constants.inside;
	  }
	
	  // bottom is within the viewport
	  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
	    return constants.inside;
	  }
	
	  // top is above the viewport and bottom is below the viewport
	  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
	    return constants.inside;
	  }
	
	  if (bounds.viewportBottom < bounds.waypointTop) {
	    return constants.below;
	  }
	
	  if (bounds.waypointTop < bounds.viewportTop) {
	    return constants.above;
	  }
	
	  return constants.invisible;
	}
	
	var timeout = void 0;
	var timeoutQueue = [];
	
	function onNextTick(cb) {
	  timeoutQueue.push(cb);
	
	  if (!timeout) {
	    timeout = setTimeout(function () {
	      timeout = null;
	
	      // Drain the timeoutQueue
	      var item = void 0;
	      // eslint-disable-next-line no-cond-assign
	      while (item = timeoutQueue.shift()) {
	        item();
	      }
	    }, 0);
	  }
	
	  var isSubscribed = true;
	
	  return function () {
	    function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      var index = timeoutQueue.indexOf(cb);
	      if (index === -1) {
	        return;
	      }
	
	      timeoutQueue.splice(index, 1);
	
	      if (!timeoutQueue.length && timeout) {
	        clearTimeout(timeout);
	        timeout = null;
	      }
	    }
	
	    return unsubscribe;
	  }();
	}
	
	function resolveScrollableAncestorProp(scrollableAncestor) {
	  // When Waypoint is rendered on the server, `window` is not available.
	  // To make Waypoint easier to work with, we allow this to be specified in
	  // string form and safely convert to `window` here.
	  if (scrollableAncestor === 'window') {
	    return global.window;
	  }
	
	  return scrollableAncestor;
	}
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultProps = {
	  topOffset: '0px',
	  bottomOffset: '0px',
	  horizontal: false,
	  onEnter: function () {
	    function onEnter() {}
	
	    return onEnter;
	  }(),
	  onLeave: function () {
	    function onLeave() {}
	
	    return onLeave;
	  }(),
	  onPositionChange: function () {
	    function onPositionChange() {}
	
	    return onPositionChange;
	  }(),
	
	  fireOnRapidScroll: true
	};
	
	// React.PureComponent was added in React 15.3.0
	var BaseClass = typeof React.PureComponent !== 'undefined' ? React.PureComponent : React.Component;
	
	// Calls a function when you scroll to the element.
	
	var Waypoint = function (_BaseClass) {
	  _inherits(Waypoint, _BaseClass);
	
	  function Waypoint(props) {
	    _classCallCheck(this, Waypoint);
	
	    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));
	
	    _this.refElement = function (e) {
	      return _this._ref = e;
	    };
	    return _this;
	  }
	
	  _createClass(Waypoint, [{
	    key: 'componentWillMount',
	    value: function () {
	      function componentWillMount() {
	        ensureChildrenIsValid(this.props.children);
	      }
	
	      return componentWillMount;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        var _this2 = this;
	
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        // this._ref may occasionally not be set at this time. To help ensure that
	        // this works smoothly and to avoid layout thrashing, we want to delay the
	        // initial execution until the next tick.
	        this.cancelOnNextTick = onNextTick(function () {
	          _this2.cancelOnNextTick = null;
	
	          // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint
	          ensureRefIsProvidedByChild(_this2.props.children, _this2._ref);
	
	          _this2._handleScroll = _this2._handleScroll.bind(_this2);
	          _this2.scrollableAncestor = _this2._findScrollableAncestor();
	
	          if (false) {
	            debugLog('scrollableAncestor', _this2.scrollableAncestor);
	          }
	
	          _this2.scrollEventListenerUnsubscribe = consolidatedEvents.addEventListener(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, { passive: true });
	
	          _this2.resizeEventListenerUnsubscribe = consolidatedEvents.addEventListener(window, 'resize', _this2._handleScroll, { passive: true });
	
	          _this2._handleScroll(null);
	        });
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(newProps) {
	        ensureChildrenIsValid(newProps.children);
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate() {
	        var _this3 = this;
	
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        if (!this.scrollableAncestor) {
	          // The Waypoint has not yet initialized.
	          return;
	        }
	
	        // The element may have moved, so we need to recompute its position on the
	        // page. This happens via handleScroll in a way that forces layout to be
	        // computed.
	        //
	        // We want this to be deferred to avoid forcing layout during render, which
	        // causes layout thrashing. And, if we already have this work enqueued, we
	        // can just wait for that to happen instead of enqueueing again.
	        if (this.cancelOnNextTick) {
	          return;
	        }
	
	        this.cancelOnNextTick = onNextTick(function () {
	          _this3.cancelOnNextTick = null;
	          _this3._handleScroll(null);
	        });
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        if (this.scrollEventListenerUnsubscribe) {
	          this.scrollEventListenerUnsubscribe();
	        }
	        if (this.resizeEventListenerUnsubscribe) {
	          this.resizeEventListenerUnsubscribe();
	        }
	
	        if (this.cancelOnNextTick) {
	          this.cancelOnNextTick();
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	
	    /**
	     * Traverses up the DOM to find an ancestor container which has an overflow
	     * style that allows for scrolling.
	     *
	     * @return {Object} the closest ancestor element with an overflow style that
	     *   allows for scrolling. If none is found, the `window` object is returned
	     *   as a fallback.
	     */
	
	  }, {
	    key: '_findScrollableAncestor',
	    value: function () {
	      function _findScrollableAncestor() {
	        var _props = this.props,
	            horizontal = _props.horizontal,
	            scrollableAncestor = _props.scrollableAncestor;
	
	
	        if (scrollableAncestor) {
	          return resolveScrollableAncestorProp(scrollableAncestor);
	        }
	
	        var node = this._ref;
	
	        while (node.parentNode) {
	          node = node.parentNode;
	
	          if (node === document.body) {
	            // We've reached all the way to the root node.
	            return window;
	          }
	
	          var style = window.getComputedStyle(node);
	          var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
	          var overflow = overflowDirec || style.getPropertyValue('overflow');
	
	          if (overflow === 'auto' || overflow === 'scroll') {
	            return node;
	          }
	        }
	
	        // A scrollable ancestor element was not found, which means that we need to
	        // do stuff on window.
	        return window;
	      }
	
	      return _findScrollableAncestor;
	    }()
	
	    /**
	     * @param {Object} event the native scroll event coming from the scrollable
	     *   ancestor, or resize event coming from the window. Will be undefined if
	     *   called by a React lifecyle method
	     */
	
	  }, {
	    key: '_handleScroll',
	    value: function () {
	      function _handleScroll(event) {
	        if (!this._ref) {
	          // There's a chance we end up here after the component has been unmounted.
	          return;
	        }
	
	        var bounds = this._getBounds();
	        var currentPosition = getCurrentPosition(bounds);
	        var previousPosition = this._previousPosition;
	
	        if (false) {
	          debugLog('currentPosition', currentPosition);
	          debugLog('previousPosition', previousPosition);
	        }
	
	        // Save previous position as early as possible to prevent cycles
	        this._previousPosition = currentPosition;
	
	        if (previousPosition === currentPosition) {
	          // No change since last trigger
	          return;
	        }
	
	        var callbackArg = {
	          currentPosition: currentPosition,
	          previousPosition: previousPosition,
	          event: event,
	          waypointTop: bounds.waypointTop,
	          waypointBottom: bounds.waypointBottom,
	          viewportTop: bounds.viewportTop,
	          viewportBottom: bounds.viewportBottom
	        };
	        this.props.onPositionChange.call(this, callbackArg);
	
	        if (currentPosition === constants.inside) {
	          this.props.onEnter.call(this, callbackArg);
	        } else if (previousPosition === constants.inside) {
	          this.props.onLeave.call(this, callbackArg);
	        }
	
	        var isRapidScrollDown = previousPosition === constants.below && currentPosition === constants.above;
	        var isRapidScrollUp = previousPosition === constants.above && currentPosition === constants.below;
	
	        if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
	          // If the scroll event isn't fired often enough to occur while the
	          // waypoint was visible, we trigger both callbacks anyway.
	          this.props.onEnter.call(this, {
	            currentPosition: constants.inside,
	            previousPosition: previousPosition,
	            event: event,
	            waypointTop: bounds.waypointTop,
	            waypointBottom: bounds.waypointBottom,
	            viewportTop: bounds.viewportTop,
	            viewportBottom: bounds.viewportBottom
	          });
	          this.props.onLeave.call(this, {
	            currentPosition: currentPosition,
	            previousPosition: constants.inside,
	            event: event,
	            waypointTop: bounds.waypointTop,
	            waypointBottom: bounds.waypointBottom,
	            viewportTop: bounds.viewportTop,
	            viewportBottom: bounds.viewportBottom
	          });
	        }
	      }
	
	      return _handleScroll;
	    }()
	  }, {
	    key: '_getBounds',
	    value: function () {
	      function _getBounds() {
	        var horizontal = this.props.horizontal;
	
	        var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
	            left = _ref$getBoundingClien.left,
	            top = _ref$getBoundingClien.top,
	            right = _ref$getBoundingClien.right,
	            bottom = _ref$getBoundingClien.bottom;
	
	        var waypointTop = horizontal ? left : top;
	        var waypointBottom = horizontal ? right : bottom;
	
	        var contextHeight = void 0;
	        var contextScrollTop = void 0;
	        if (this.scrollableAncestor === window) {
	          contextHeight = horizontal ? window.innerWidth : window.innerHeight;
	          contextScrollTop = 0;
	        } else {
	          contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
	          contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
	        }
	
	        if (false) {
	          debugLog('waypoint top', waypointTop);
	          debugLog('waypoint bottom', waypointBottom);
	          debugLog('scrollableAncestor height', contextHeight);
	          debugLog('scrollableAncestor scrollTop', contextScrollTop);
	        }
	
	        var _props2 = this.props,
	            bottomOffset = _props2.bottomOffset,
	            topOffset = _props2.topOffset;
	
	        var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
	        var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
	        var contextBottom = contextScrollTop + contextHeight;
	
	        return {
	          waypointTop: waypointTop,
	          waypointBottom: waypointBottom,
	          viewportTop: contextScrollTop + topOffsetPx,
	          viewportBottom: contextBottom - bottomOffsetPx
	        };
	      }
	
	      return _getBounds;
	    }()
	
	    /**
	     * @return {Object}
	     */
	
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this4 = this;
	
	        var children = this.props.children;
	
	
	        if (!children) {
	          // We need an element that we can locate in the DOM to determine where it is
	          // rendered relative to the top of its context.
	          return React.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
	        }
	
	        if (isDOMElement(children)) {
	          var ref = function () {
	            function ref(node) {
	              _this4.refElement(node);
	              if (children.ref) {
	                children.ref(node);
	              }
	            }
	
	            return ref;
	          }();
	
	          return React.cloneElement(children, { ref: ref });
	        }
	
	        return React.cloneElement(children, { innerRef: this.refElement });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return Waypoint;
	}(BaseClass);
	
	
	Waypoint.propTypes = {
	  children: PropTypes.node,
	  debug: PropTypes.bool,
	  onEnter: PropTypes.func,
	  onLeave: PropTypes.func,
	  onPositionChange: PropTypes.func,
	  fireOnRapidScroll: PropTypes.bool,
	  scrollableAncestor: PropTypes.any,
	  horizontal: PropTypes.bool,
	
	  // `topOffset` can either be a number, in which case its a distance from the
	  // top of the container in pixels, or a string value. Valid string values are
	  // of the form "20px", which is parsed as pixels, or "20%", which is parsed
	  // as a percentage of the height of the containing element.
	  // For instance, if you pass "-20%", and the containing element is 100px tall,
	  // then the waypoint will be triggered when it has been scrolled 20px beyond
	  // the top of the containing element.
	  topOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	
	  // `bottomOffset` is like `topOffset`, but for the bottom of the container.
	  bottomOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	
	Waypoint.above = constants.above;
	Waypoint.below = constants.below;
	Waypoint.inside = constants.inside;
	Waypoint.invisible = constants.invisible;
	Waypoint.getWindow = function () {
	  if (typeof window !== 'undefined') {
	    return window;
	  }
	};
	Waypoint.defaultProps = defaultProps;
	Waypoint.displayName = 'Waypoint';
	
	module.exports = Waypoint;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Whistle_Volara_Co-Marketing_Flyer.a60854f5.pdf";

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/White_Paper_Survey.1600309d.pdf";

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _emotion = __webpack_require__(5);
	
	var _White_Paper_Survey = __webpack_require__(74);
	
	var _White_Paper_Survey2 = _interopRequireDefault(_White_Paper_Survey);
	
	var _Whistle_Volara_CoMarketing_Flyer = __webpack_require__(73);
	
	var _Whistle_Volara_CoMarketing_Flyer2 = _interopRequireDefault(_Whistle_Volara_CoMarketing_Flyer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e18b6dck0'
	})('display:flex;flex-wrap:wrap;max-width:1000px;margin:0 auto;margin-top:1rem;');
	var Icon = /*#__PURE__*/(0, _emotion.css)('font-size:2rem !important;color:#FBBD08;margin-bottom:.5rem;margin-top:1rem !important;@media (min-width:767px){font-size:4rem !important;margin-top:1.5rem !important;}');
	
	var FeaturedIconClass = /*#__PURE__*/(0, _emotion.css)(Icon);
	
	var IconWithLink = /*#__PURE__*/(0, _emotion.css)('transition:.25s ease-out;opacity:1;position:relative;left:-1rem;@media (min-width:767px){left:-2rem;}');
	
	var FeaturedIconLinkClass = /*#__PURE__*/(0, _emotion.css)('opacity:0;transform:translateX(-100px);transition:.25s ease-out;position:relative;left:1rem;@media (min-width:767px){left:2rem;}', Icon);
	
	var FeaturedTitleClass = /*#__PURE__*/(0, _emotion.css)('opacity:1;transition:.25s ease-out;');
	
	var FeaturedDescClass = /*#__PURE__*/(0, _emotion.css)('opacity:0;height:0;transform:translateY(100px);transition:.25s ease-out;font-size:.8rem;@media (min-width:767px){font-size:1rem;}');
	
	var FeaturedClass = /*#__PURE__*/(0, _emotion.css)('align-items:center;justify-content:center;text-align:center;flex-direction:column;background-color:white;height:130px;margin:.5rem;flex:1 100px;border-radius:8px;box-shadow:2px 2px 10px rgba(0,0,0,0.15);padding:1rem;overflow:hidden;cursor:default;color:#232323;&.link{cursor:pointer;}&:hover{.', FeaturedIconLinkClass, '{transform:translateX(0);opacity:1;}.', IconWithLink, '{opacity:0;transform:translateX(100px)}.', FeaturedDescClass, '{opacity:1;height:auto;transform:translateY(0px);}.', FeaturedTitleClass, '{opacity:0;height:0;margin:0;}}@media (min-width:767px){height:170px;max-width:186px;margin:1rem;flex:1 140px;}');
	
	var FeatureList = function FeatureList(props) {
	  var features = [{
	    label: 'Multi-Channel Guest Messaging',
	    icon: 'device_hub',
	    description: 'Communicate with your guests through the channel they want.'
	  }, {
	    label: 'Team Messaging',
	    icon: 'people',
	    description: 'Streamline internal communication with direct messages or team messages.'
	  }, {
	    label: 'Website Live Chat',
	    icon: 'language',
	    description: 'Give your website visitors a convenient way to chat with your team.'
	  }, {
	    label: 'Automated Messaging',
	    icon: 'all_inclusive',
	    description: 'Take the work out of arrival, mid-stay, and departure messaging!'
	  }, {
	    label: 'PMS & Task Management Integrations',
	    icon: 'power',
	    description: 'One-click integrations with your favorite PMS & Task Management Tool!',
	    link: '#partners'
	  }, {
	    label: 'Guest Surveys',
	    icon: 'ballot',
	    description: 'Send surveys via messaging, collect and review results instantly.',
	    link: _White_Paper_Survey2.default,
	    target: "_blank"
	  }, {
	    label: 'Translation',
	    icon: 'g_translate',
	    description: 'Real-time translation for any guest from any part of the world, or even with your staff!'
	  }, {
	    label: 'Analytics & Reporting',
	    icon: 'insert_chart',
	    description: 'Robust in-app and email analytics with Sentiment Analysis, Team Activity, and more!'
	  }, {
	    label: 'Machine Learning',
	    icon: 'memory',
	    description: 'Machine Learning & AI powering your Whistle system for a unique experience.',
	    link: 'https://www.trywhistle.com/blog/2019-05-15-conversational-artificial-intelligence-in-hospitality-comes-to-life/',
	    target: "_blank"
	  }, {
	    label: 'Voice Enablement',
	    icon: 'record_voice_over',
	    description: 'Seamless cross-channel guest communication.',
	    link: _Whistle_Volara_CoMarketing_Flyer2.default,
	    target: "_blank"
	  }, {
	    label: 'Opt-In Engine',
	    icon: 'notification_important',
	    description: 'Industry leading engine for automated guest consent (opt-in/opt-out).',
	    link: 'https://www.hospitalitynet.org/news/4090516.html',
	    target: "_blank"
	  }, {
	    label: 'Automatic & Suggested Replies',
	    icon: 'repeat',
	    description: 'Let our system do the work for you!'
	  }];
	  return _react2.default.createElement(
	    List,
	    null,
	    features.map(function (feature) {
	      return feature.link ? _react2.default.createElement(
	        'a',
	        { className: FeaturedClass + ' link', key: feature.label, href: feature.link, title: 'Surveys Case Study', target: feature.target },
	        _react2.default.createElement(
	          'i',
	          { className: FeaturedIconLinkClass + ' material-icons' },
	          'arrow_forward'
	        ),
	        _react2.default.createElement(
	          'i',
	          { className: FeaturedIconClass + ' ' + IconWithLink + ' material-icons' },
	          feature.icon
	        ),
	        _react2.default.createElement(
	          'h4',
	          { className: FeaturedTitleClass },
	          feature.label
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: FeaturedDescClass },
	          feature.description
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { className: FeaturedClass, key: feature.label },
	        _react2.default.createElement(
	          'i',
	          { className: FeaturedIconClass + ' material-icons' },
	          feature.icon
	        ),
	        _react2.default.createElement(
	          'h4',
	          { className: FeaturedTitleClass },
	          feature.label
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: FeaturedDescClass },
	          feature.description
	        )
	      );
	    })
	  );
	};
	
	exports.default = FeatureList;
	module.exports = exports['default'];

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _emotion = __webpack_require__(5);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Button = __webpack_require__(13);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _mobilePhoneVector = __webpack_require__(54);
	
	var _mobilePhoneVector2 = _interopRequireDefault(_mobilePhoneVector);
	
	var _desktopVector = __webpack_require__(52);
	
	var _desktopVector2 = _interopRequireDefault(_desktopVector);
	
	var _graphVector = __webpack_require__(53);
	
	var _graphVector2 = _interopRequireDefault(_graphVector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShowMobile = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1nfmcfg0'
	})('@media (min-width:767px){display:none;}');
	
	var ShowTabletUp = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1nfmcfg1'
	})('display:none;@media (min-width:767px){display:flex;}');
	
	var HowItWorksContainer = /*#__PURE__*/(0, _emotion.css)('display:flex;flex-direction:column;margin-bottom:2rem;@media (min-width:767px){margin-bottom:0;flex-direction:row;display:block;}');
	
	var MobileIsometricWrapper = /*#__PURE__*/(0, _emotion.css)('padding:4%;@media (min-width:767px){width:25%;display:inline-block;}@media (min-width:1025px){padding:2rem 6%;width:20%;display:inline-block;}');
	
	var Col = /*#__PURE__*/(0, _emotion.css)('padding:4%;@media (min-width:767px){width:25%;display:inline-block;}@media (min-width:1025px){padding:1rem 6%;width:20%;display:inline-block;}');
	
	var HowItWorksActivate = /*#__PURE__*/(0, _emotion.css)('text-align:center;');
	
	var explainerButton = /*#__PURE__*/(0, _emotion.css)('margin-top:2rem;@media (min-width:767px){margin-top:0;margin-left:1rem;}');
	
	var Desc = function Desc(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h4',
	      null,
	      props.header
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      props.description
	    )
	  );
	};
	
	var HowItWorks = function HowItWorks(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: HowItWorksContainer },
	      _react2.default.createElement(
	        'div',
	        { className: MobileIsometricWrapper },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_mobilePhoneVector2.default, null)
	        ),
	        _react2.default.createElement(
	          ShowMobile,
	          null,
	          _react2.default.createElement(Desc, {
	            header: 'Personalized and Automated Guest Engagement, from Booking to Departure',
	            description: 'Drive Guest Engagement and Satisfaction throughout their entire journey!'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: MobileIsometricWrapper },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_desktopVector2.default, null)
	        ),
	        _react2.default.createElement(
	          ShowMobile,
	          null,
	          _react2.default.createElement(Desc, {
	            header: 'Digital Front Office Platform',
	            description: 'All Guest Communications, Team Collaboration, Service Requests, Work Orders, Purchases, and more!'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: MobileIsometricWrapper },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_graphVector2.default, null)
	        ),
	        _react2.default.createElement(
	          ShowMobile,
	          null,
	          _react2.default.createElement(Desc, {
	            header: 'Satisfaction Goes Up, Costs Come Down',
	            description: 'Automating mundane processes means less work and more instant gratification. Let us do the heavy lifting!'
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        ShowTabletUp,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: Col },
	          _react2.default.createElement(Desc, {
	            header: 'Personalized and Automated Guest Engagement, from Booking to Departure',
	            description: 'Drive Guest Engagement and Satisfaction throughout their entire journey!'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: Col },
	          _react2.default.createElement(Desc, {
	            header: 'Digital Front Office Platform',
	            description: 'All Guest Communications, Team Collaboration, Service Requests, Work Orders, Purchases, and more!'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: Col },
	          _react2.default.createElement(Desc, {
	            header: 'Satisfaction Goes Up, Costs Come Down',
	            description: 'Automating mundane processes means less work and more instant gratification. Let us do the heavy lifting!'
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: HowItWorksActivate },
	      _react2.default.createElement(
	        _Button2.default,
	        { to: '/schedule' },
	        'Activate Yours Today'
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { className: explainerButton, flat: true, to: '/#how-it-works', onClick: function onClick() {
	            return props.toggleVideo();
	          } },
	        'Watch Explainer Video'
	      )
	    )
	  );
	};
	
	exports.default = HowItWorks;
	module.exports = exports['default'];

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _emotion = __webpack_require__(5);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ItemClass = /*#__PURE__*/(0, _emotion.css)('flex:1 80px;height:100px;align-items:center;justify-content:center;display:flex;padding:0 .5rem;position:relative;@media (min-width:800px){flex:1 110px;padding:0 1rem;margin-top:2rem;}');
	
	var HoverVielClass = /*#__PURE__*/(0, _emotion.css)('position:absolute;left:0;right:0;top:0;transition:.25s ease-out;opacity:0;height:0;color:#fff;');
	
	var ListClass = /*#__PURE__*/(0, _emotion.css)('display:flex;flex-wrap:wrap;max-width:800px;margin:0 auto;@media (min-width:800px){max-width:1000px;}@media (min-width:1025px){&:hover{.', ItemClass, '{}.', HoverVielClass, '{height:auto;opacity:.8;bottom:0;display:flex;align-items:center;justify-content:center;font-size:3rem;font-style:italic;font-weight:bold;background-color:#00B386;}}}');
	
	var ItemImgClass = /*#__PURE__*/(0, _emotion.css)('width:90px;@media (min-width:767px){width:100px;}@media (min-width:1025px){width:90%;max-width:150px;}');
	
	var PartnersList = function PartnersList(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: ListClass },
	    props.partners.map(function (partner) {
	      return _react2.default.createElement(
	        'div',
	        { key: partner.node.id, className: ItemClass },
	        _react2.default.createElement('img', { className: ItemImgClass, src: partner.node.frontmatter.logo, alt: partner.node.frontmatter.title, title: partner.node.frontmatter.title })
	      );
	    }),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/testimonials', className: HoverVielClass },
	      'Read Their Stories'
	    )
	  );
	};
	
	exports.default = PartnersList;
	module.exports = exports['default'];

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _emotion = __webpack_require__(5);
	
	var _reactWaypoint = __webpack_require__(83);
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopMessageClass = /*#__PURE__*/(0, _emotion.css)('opacity:0;transition:.5s ease-out;transition-delay:.5s;&.is-active{opacity:1;}');
	
	var SecondMessageClass = /*#__PURE__*/(0, _emotion.css)('transition-delay:1s;');
	
	var ThirdMessageClass = /*#__PURE__*/(0, _emotion.css)('transition-delay:2s;');
	
	var DesktopVector = function (_React$Component) {
	  _inherits(DesktopVector, _React$Component);
	
	  function DesktopVector(props) {
	    _classCallCheck(this, DesktopVector);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      active: false
	    };
	    return _this;
	  }
	
	  DesktopVector.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactWaypoint2.default, {
	        onEnter: function onEnter() {
	          return _this2.setState({ active: true });
	        }
	      }),
	      _react2.default.createElement(
	        'svg',
	        { viewBox: '0 0 298 389', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement(
	          'g',
	          { id: 'Main_Desktop', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', transform: 'translate(-818.000000, -1498.000000)' },
	          _react2.default.createElement(
	            'g',
	            { id: 'How-It-Works', transform: 'translate(149.000000, 1363.000000)' },
	            _react2.default.createElement(
	              'g',
	              { id: 'Desktop_Vector', transform: 'translate(668.000000, 135.000000)' },
	              _react2.default.createElement('path', { d: 'M75.2770233,224.210466 L295.060967,343.52175 C298.458609,345.366184 299.717732,349.615725 297.873298,353.013367 C297.179802,354.29086 296.105812,355.320776 294.800396,355.960163 L230.061954,387.668788 C226.784928,389.273862 222.925237,389.149391 219.758435,387.336512 L5.38916143,264.61787 C2.03403648,262.697183 0.87119515,258.420292 2.79188262,255.065167 C3.52910199,253.777366 4.65649064,252.757155 6.01129331,252.151818 L69.0817998,223.971379 C71.071504,223.082362 73.3617531,223.170748 75.2770233,224.210466 Z', id: 'Path-19-Copy-2', fillOpacity: '0.05', fill: '#000000' }),
	              _react2.default.createElement('path', { d: 'M106.895399,257.960197 L81.1907661,271.90116 C78.817982,273.188045 77.9376866,276.154793 79.2245711,278.527577 C79.6514405,279.314647 80.2863168,279.969332 81.0599047,280.420175 L149.983576,320.588515 C155.678141,323.907276 162.716161,323.912812 168.41594,320.603015 L189.08937,308.598187 L106.895399,257.960197 Z', id: 'Path-22', stroke: '#00B386', strokeWidth: '1.37460937', fill: '#00B386' }),
	              _react2.default.createElement('path', { d: 'M6,14.1113965 L25.4184428,3.15314178 C31.0759623,-0.0395210327 38.0008006,0.00111595295 43.6204608,3.25995657 L270.12244,134.608441 C275.776099,137.886997 279.2562,143.928027 279.2562,150.463529 L279.2562,317.941734 C279.2562,324.594616 275.651076,330.725093 269.837031,333.958933 L250.218226,344.871145 L15.1786034,209.45782 C9.49966898,206.186017 6,200.130817 6,193.576812 L6,14.1113965 Z', id: 'Path-19', stroke: '#00B386', strokeWidth: '1.37460937', fill: '#FFFFFF' }),
	              _react2.default.createElement('path', { d: 'M6,14.1064321 L241.203536,150.106918 C246.868414,153.38249 250.357195,159.429813 250.357195,165.973529 L250.357195,344.871145 L269.735824,334.252013 C275.606466,331.035009 279.2562,324.87323 279.2562,318.178938 L279.2562,150.749052 C279.2562,144.214191 275.776777,138.173654 270.123995,134.894865 L43.2507722,3.3013492 C37.5939346,0.0202076931 30.617399,0.00169006874 24.9432231,3.25275599 L6,14.1064321 Z', id: 'Path-20', stroke: '#00B386', strokeWidth: '1.37460937', fill: '#00B386' }),
	              _react2.default.createElement(
	                'g',
	                { id: 'Interface', transform: 'translate(26.000000, 54.000000)' },
	                _react2.default.createElement('path', { d: 'M253.777778,105.187294 C252.57147,114.090871 243.005353,121.134667 225.079427,126.318682 C225.079427,134.094704 225.079427,188.518904 225.079427,289.591283 C243.804253,282.545709 253.37037,274.95483 253.777778,266.818646 C253.777778,266.818646 255.121101,184.051022 253.777778,113.003545 C253.777778,108.799127 253.777778,106.19371 253.777778,105.187294 Z', id: 'Path-7', fillOpacity: '0.45', fill: '#353947' }),
	                _react2.default.createElement('polygon', { id: 'Path-64', fill: '#00B386', points: '1 132.012739 34.1197841 151.736166 34.1197841 25.9736328 1 8' }),
	                _react2.default.createElement('polygon', { id: 'Path-64-Copy', fill: '#00B386', points: '160.410853 223.707006 193.530637 243.430434 193.530637 119.40375 160.410853 99.6942675' }),
	                _react2.default.createElement(
	                  'g',
	                  { className: TopMessageClass + ' ' + SecondMessageClass + ' ' + (this.state.active ? 'is-active' : ''), id: 'Group-9', transform: 'translate(39.000000, 91.000000)' },
	                  _react2.default.createElement('path', { d: 'M24.0620155,17.7159572 L27.8584211,15.5235681 L27.8584211,9.21186421 C27.8584211,7.55500996 29.2015669,6.21186421 30.8584211,6.21186421 C31.3866131,6.21186421 31.9054428,6.35131663 32.3624592,6.61612358 L73.7503804,30.5973371 C76.5281612,32.2068539 78.2382661,35.1741679 78.2382661,38.384559 L78.2382661,59.1412401 C78.2382661,60.7980943 76.8951204,62.1412401 75.2382661,62.1412401 C74.702999,62.1412401 74.1774796,61.998029 73.7162183,61.7264616 L32.2922776,37.3381377 C29.5450042,35.7206819 27.8584211,32.770525 27.8584211,29.5824731 L27.8584211,24.1668802 L24.0620155,17.7159572 Z', id: 'Path-65', fill: '#FBBD08' }),
	                  _react2.default.createElement('ellipse', { id: 'Oval-5', fill: '#984983', transform: 'translate(11.775540, 13.870535) rotate(330.000000) translate(-11.775540, -13.870535) ', cx: '11.7755399', cy: '13.8705348', rx: '7.51937984', ry: '10.522293' })
	                ),
	                _react2.default.createElement(
	                  'g',
	                  { className: TopMessageClass + ' ' + (this.state.active ? 'is-active' : ''), id: 'Group-8-Copy', transform: 'translate(76.000000, 66.000000)' },
	                  _react2.default.createElement('path', { d: 'M4.5040381,0.918391447 L45.8919593,24.8996049 C48.66974,26.5091217 50.379845,29.4764358 50.379845,32.6868268 L50.379845,34.6281526 L54.4626332,40.2599575 L50.379845,42.7077705 L50.379845,44.7153157 C50.379845,46.37217 49.0366992,47.7153157 47.379845,47.7153157 C46.8445779,47.7153157 46.3190584,47.5721046 45.8577971,47.3005373 L4.43385645,22.9122134 C1.68658305,21.2947576 6.64231437e-14,18.3446007 5.32907052e-14,15.1565488 L4.4408921e-16,3.51413207 C-7.11672786e-15,1.85727782 1.34314575,0.514132074 3,0.514132074 C3.52819199,0.514132074 4.04702163,0.65358449 4.5040381,0.918391447 Z', id: 'Path-65-Copy', fill: '#00B386' }),
	                  _react2.default.createElement('ellipse', { id: 'Oval-5-Copy', fill: '#FBBD08', transform: 'translate(65.915075, 45.946968) rotate(330.000000) translate(-65.915075, -45.946968) ', cx: '65.9150747', cy: '45.9469679', rx: '7.51937984', ry: '10.522293' })
	                ),
	                _react2.default.createElement(
	                  'g',
	                  { className: TopMessageClass + ' ' + ThirdMessageClass + ' ' + (this.state.active ? 'is-active' : ''), id: 'Group-8-Copy-2', transform: 'translate(76.000000, 142.000000)' },
	                  _react2.default.createElement('path', { d: 'M4.5040381,0.918391447 L45.8919593,24.8996049 C48.66974,26.5091217 50.379845,29.4764358 50.379845,32.6868268 L50.379845,34.6281526 L54.4626332,40.2599575 L50.379845,42.7077705 L50.379845,44.7153157 C50.379845,46.37217 49.0366992,47.7153157 47.379845,47.7153157 C46.8445779,47.7153157 46.3190584,47.5721046 45.8577971,47.3005373 L4.43385645,22.9122134 C1.68658305,21.2947576 6.64231437e-14,18.3446007 5.32907052e-14,15.1565488 L4.4408921e-16,3.51413207 C-7.11672786e-15,1.85727782 1.34314575,0.514132074 3,0.514132074 C3.52819199,0.514132074 4.04702163,0.65358449 4.5040381,0.918391447 Z', id: 'Path-65-Copy', fill: '#00B386' }),
	                  _react2.default.createElement('ellipse', { id: 'Oval-5-Copy', fill: '#FBBD08', transform: 'translate(65.915075, 45.946968) rotate(330.000000) translate(-65.915075, -45.946968) ', cx: '65.9150747', cy: '45.9469679', rx: '7.51937984', ry: '10.522293' })
	                ),
	                _react2.default.createElement('polygon', { id: 'Path-23', fill: '#00B386', points: '0.992980957 8.01464844 7.74766942 0.619137376 27.0573236 10.963595 27.0573236 15.7329102 193.550781 112.587871 193.550781 119.462891' })
	              ),
	              _react2.default.createElement('polygon', { id: 'Path-26', fill: '#00B386', points: '27.2855351 185.961856 27.2855351 192.851805 219.766926 305.794007 219.766926 295.876907' })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return DesktopVector;
	}(_react2.default.Component);
	
	exports.default = DesktopVector;
	module.exports = exports['default'];

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GraphVector = function GraphVector(props) {
	    return _react2.default.createElement(
	        "svg",
	        { viewBox: "0 0 316 388", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { id: "Main_Desktop", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", transform: "translate(-1406.000000, -1480.000000)" },
	            _react2.default.createElement(
	                "g",
	                { id: "How-It-Works", transform: "translate(149.000000, 1363.000000)" },
	                _react2.default.createElement(
	                    "g",
	                    { id: "Graph-New", transform: "translate(1257.000000, 116.000000)" },
	                    _react2.default.createElement("path", { d: "M4.30076432,365.174138 L38.3329985,386.712219 C41.1429006,388.490531 44.7044051,388.574536 47.5950264,386.930685 L313.672407,235.616565 C315.112658,234.797516 315.616242,232.965991 314.797194,231.52574 C314.488656,230.983193 314.018582,230.550386 313.452455,230.287609 L274.437606,212.178216 L4.46424092,360.007811 C3.01099085,360.803569 2.47798793,362.62675 3.27374557,364.08 C3.51786762,364.525827 3.87126295,364.902318 4.30076432,365.174138 Z", id: "Path-25-Copy", fillOpacity: "0.05", fill: "#000000" }),
	                    _react2.default.createElement(
	                        "g",
	                        { id: "Graph", transform: "translate(0.000000, 0.960159)" },
	                        _react2.default.createElement("polygon", { id: "Path-129", fill: "#FBBD08", points: "307.530488 140.737052 285.463415 153.87251 285.463415 171.699203 307.530488 159.032869 299.54878 156.218127" }),
	                        _react2.default.createElement("polygon", { id: "Path-129-Copy", fillOpacity: "0.05", fill: "#000000", points: "307.530488 140.737052 285.463415 153.87251 285.463415 171.699203 307.530488 159.032869 299.54878 156.218127" }),
	                        _react2.default.createElement("path", { d: "M285.463415,153.407837 C288.092582,152.466623 290.640227,151.996016 293.10635,151.996016 C295.572473,151.996016 296.985879,152.418945 297.346567,153.264804 L297.346567,175.522089 L285.463415,171.062177 L285.463415,153.407837 Z", id: "Path-131", fill: "#FBBD08" }),
	                        _react2.default.createElement("path", { d: "M285.463415,153.407837 C288.298304,152.466623 290.845949,151.996016 293.10635,151.996016 C295.366751,151.996016 296.780156,152.418945 297.346567,153.264804 L297.346567,175.522089 L285.463415,171.062177 L285.463415,153.407837 Z", id: "Path-131-Copy", fillOpacity: "0.3", fill: "#353947" }),
	                        _react2.default.createElement(
	                            "g",
	                            { id: "Group-5", transform: "translate(211.243902, 65.677291)" },
	                            _react2.default.createElement("path", { d: "M45.7881372,0 L70.8858631,14.478183 C73.7881388,16.1524254 75.5762745,19.2482855 75.5762745,22.5988513 L75.5762745,169.861662 L45.7881372,187.045614 L16,169.861662 L16,17.1839514 L45.7881372,0 Z", id: "Polygon-3-Copy-3", stroke: "#984983", strokeWidth: "1.875", fill: "#FFFFFF" }),
	                            _react2.default.createElement("path", { d: "M16,16.563175 L40.3786137,29.4167332 C43.4554322,31.0389775 45.3811928,34.2313674 45.3811928,37.7096556 L45.3811928,186.737727 L16,169.814463 L16,16.563175 Z", id: "Path-24-Copy-3", fill: "#984983" })
	                        ),
	                        _react2.default.createElement(
	                            "g",
	                            { id: "Group-4", transform: "translate(146.390244, 133.231076)" },
	                            _react2.default.createElement("path", { d: "M46.7881372,0.216236616 L71.8858631,14.6944196 C74.7881388,16.368662 76.5762745,19.4645221 76.5762745,22.8150879 L76.5762745,139.837758 L46.7881372,157.021709 L17,139.837758 L17,17.400188 L46.7881372,0.216236616 Z", id: "Polygon-3-Copy-2", stroke: "#984983", strokeWidth: "1.875", fill: "#FFFFFF" }),
	                            _react2.default.createElement("path", { d: "M17,17.1777623 L41.7174851,31.5452331 C44.6047047,33.22348 46.3811928,36.3108948 46.3811928,39.6504382 L46.3811928,158.590316 L17,141.667052 L17,17.1777623 Z", id: "Path-24-Copy-2", fill: "#984983" })
	                        ),
	                        _react2.default.createElement(
	                            "g",
	                            { id: "Group-3", transform: "translate(83.536585, 192.402390)" },
	                            _react2.default.createElement("path", { d: "M45.7881372,0.194798929 L70.8858631,14.6729819 C73.7881388,16.3472244 75.5762745,19.4430844 75.5762745,22.7936503 L75.5762745,116.31983 L45.7881372,133.503781 L16,116.31983 L16,17.3787503 L45.7881372,0.194798929 Z", id: "Polygon-3-Copy", stroke: "#984983", strokeWidth: "1.875", fill: "#FFFFFF" }),
	                            _react2.default.createElement("path", { d: "M16,17.7649402 L40.3786137,30.6184984 C43.4554322,32.2407427 45.3811928,35.4331326 45.3811928,38.9114208 L45.3811928,134.223018 L16,117.299754 L16,17.7649402 Z", id: "Path-24-Copy", fill: "#984983" })
	                        ),
	                        _react2.default.createElement(
	                            "g",
	                            { id: "Group-2", transform: "translate(19.682927, 247.697211)" },
	                            _react2.default.createElement("path", { d: "M45.7881372,0.186916397 L70.8858631,14.6650994 C73.7881388,16.3393418 75.5762745,19.4352019 75.5762745,22.7857677 L75.5762745,98.5548895 L45.7881372,115.738841 L16,98.5548895 L16,17.3708678 L45.7881372,0.186916397 Z", id: "Polygon-3", stroke: "#984983", strokeWidth: "1.875", fill: "#FFFFFF" }),
	                            _react2.default.createElement("path", { d: "M16,16.8884462 L40.3786137,29.7420044 C43.4554322,31.3642487 45.3811928,34.5566386 45.3811928,38.0349267 L45.3811928,114.710776 L16,97.7875121 L16,16.8884462 Z", id: "Path-24", fill: "#984983" })
	                        ),
	                        _react2.default.createElement("polygon", { id: "Path-25", fill: "#00B386", points: "0 250.492141 41.5244717 274.085408 80.8791646 250.492141 86.5012636 208.874775 148.392667 171.79964 159.58855 127.935297 225.977633 91.9836506 238.605395 40.4567614 257.720531 48.321184 231.036681 0 192.372415 22.8990911 208.24606 27.0231691 192.372415 75.3331934 133.812544 105.667395 116.812283 148.27659 48.3500513 190.920895 41.5244717 231.366497" })
	                    ),
	                    _react2.default.createElement(
	                        "g",
	                        { id: "Thumbs_Up_Emoji-Copy", transform: "translate(237.756098, 101.290837)" },
	                        _react2.default.createElement("path", { d: "M31.2279095,60.6984257 C32.3370452,60.6984257 38.6047226,60.9844613 39.6655364,60.7602695 C49.3225264,58.7193672 51.5182012,47.3526028 51.5182012,34.1331574 C51.5182012,21.0424694 51.7351923,10.3801709 42.2167601,8.18764028 C41.0672611,7.92285803 32.4353889,7.56788902 31.2279095,7.56788902 C20.0218908,7.56788902 10.9376177,19.4615648 10.9376177,34.1331574 C10.9376177,48.8047499 20.0218908,60.6984257 31.2279095,60.6984257 Z", id: "Oval-3-Copy", fill: "#FBBD08", transform: "translate(31.228116, 34.206978) rotate(30.000000) translate(-31.228116, -34.206978) " }),
	                        _react2.default.createElement("path", { d: "M31.2279095,60.6984257 C32.3370452,60.6984257 38.6047226,60.9844613 39.6655364,60.7602695 C49.3225264,58.7193672 51.5182012,47.3526028 51.5182012,34.1331574 C51.5182012,21.0424694 51.7351923,10.3801709 42.2167601,8.18764028 C41.0672611,7.92285803 32.4353889,7.56788902 31.2279095,7.56788902 C20.0218908,7.56788902 10.9376177,19.4615648 10.9376177,34.1331574 C10.9376177,48.8047499 20.0218908,60.6984257 31.2279095,60.6984257 Z", id: "Oval-3-Copy-2", fillOpacity: "0.3", fill: "#353947", transform: "translate(31.228116, 34.206978) rotate(30.000000) translate(-31.228116, -34.206978) " }),
	                        _react2.default.createElement("ellipse", { id: "Oval-3", fill: "#FBBD08", transform: "translate(38.261530, 38.337460) rotate(30.000000) translate(-38.261530, -38.337460) ", cx: "38.2615303", cy: "38.3374604", rx: "20.2902917", ry: "26.5652683" }),
	                        _react2.default.createElement("polygon", { id: "Path-44", fill: "#FFFFFF", points: "25.5872788 38.2574416 29.9851746 35.9585673 29.9851746 50.0295507 25.5872788 52.7281709" }),
	                        _react2.default.createElement("path", { d: "M30.8636605,35.4793111 L30.8636605,48.3890197 L33.8122497,46.8410436 C37.2758268,47.3071009 40.7908117,46.4415659 44.3572042,44.2444384 C45.1249359,43.8449607 45.5088017,42.8795562 45.5088017,41.3482249 C46.90958,40.2469467 47.5266757,39.1803155 47.3600887,38.1483314 C48.0278682,36.9498982 48.1159527,35.5954191 47.6243422,34.0848939 C48.5863819,32.5702076 48.8493583,30.9406568 48.4132713,29.1962415 C47.7111496,28.4647271 45.3455497,28.8396601 41.3164716,30.3210404 C42.1212949,28.4557708 42.7543253,26.5249618 43.215563,24.5286135 C43.6768006,22.5322652 42.7558163,21.5861714 40.4526101,21.6903321 C38.1632221,26.7756106 36.6686955,29.8009522 35.9690302,30.7663566 C35.269365,31.7317611 34.8222157,32.6327885 34.6275822,33.4694388 L30.8636605,35.4793111 Z", id: "Path-45", fill: "#FFFFFF" })
	                    ),
	                    _react2.default.createElement(
	                        "g",
	                        { id: "Whistle_Ribbon", transform: "translate(223.487805, 153.956175)" },
	                        _react2.default.createElement("polygon", { id: "Path-128", fill: "#FBBD08", points: "31.7360899 19.2840941 31.7360899 37.5799108 8.72999238 51.1844925 14.3641387 37.5799108 0.278772866 35.2342933" }),
	                        _react2.default.createElement("polygon", { id: "Path-128-Copy", fillOpacity: "0.05", fill: "#000000", points: "31.7360899 19.2840941 31.7360899 37.5799108 8.72999238 51.1844925 14.3641387 37.5799108 0.278772866 35.2342933" }),
	                        _react2.default.createElement("path", { d: "M31.7360899,19.3136434 C30.0145452,20.6487823 28.6798284,22.2936924 27.7319395,24.2483737 C26.7840507,26.203055 26.3972228,27.5122619 26.5714558,28.1759946 L26.5714558,48.8097838 L31.7360899,37.9615318 L31.7360899,19.3136434 Z", id: "Path-130", fill: "#FBBD08" }),
	                        _react2.default.createElement("path", { d: "M31.7360899,19.3136434 C30.0145452,20.6487823 28.6798284,22.2936924 27.7319395,24.2483737 C26.7840507,26.203055 26.3972228,27.5122619 26.5714558,28.1759946 L26.5714558,48.8097838 L31.7360899,37.9615318 L31.7360899,19.3136434 Z", id: "Path-130-Copy", fillOpacity: "0.3", fill: "#353947" }),
	                        _react2.default.createElement("polygon", { id: "Path-127", fill: "#FBBD08", points: "26.5512814 48.838875 73.8151209 22.8771073 73.8151209 0.828302488 26.5512814 28.1974407" })
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = GraphVector;
	module.exports = exports["default"];

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _emotion = __webpack_require__(5);
	
	var _hero_vector = __webpack_require__(91);
	
	var _hero_vector2 = _interopRequireDefault(_hero_vector);
	
	var _Button = __webpack_require__(13);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _whistleTopRatedX = __webpack_require__(86);
	
	var _whistleTopRatedX2 = _interopRequireDefault(_whistleTopRatedX);
	
	var _RegisterButton = __webpack_require__(89);
	
	var _RegisterButton2 = _interopRequireDefault(_RegisterButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeroWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1gbd5pt0'
	})('display:flex;flex-direction:column-reverse;@media (min-width:1025px){flex-direction:row;}');
	
	var HeroSubheader = /*#__PURE__*/(0, _reactEmotion2.default)('h2', {
	  target: 'e1gbd5pt1'
	})('font-size:1.125rem;font-weight:300;font-family:\'Roboto\';line-height:1.5rem;margin-top:2.5rem;');
	
	var HeaderWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1gbd5pt2'
	})('flex:2 400px;margin-top:2rem;@media (min-width:1025px){margin-top:0;}');
	
	var VectorWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1gbd5pt3'
	})('flex:3 280px;@media (min-width:1025px){padding-left:1rem;align-self:center;}');
	
	var CTAWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1gbd5pt4'
	})('margin-top:2.5rem;');
	var button2Style = /*#__PURE__*/(0, _emotion.css)();
	
	var anchor = /*#__PURE__*/(0, _emotion.css)('margin-top:1.5rem;color:#984983;display:block;font-size:0.9rem;font-weight:300;font-family:\'Roboto\';line-height:1.5rem;text-align:center;display:flex;&:hover{cursor:pointer;}@media (min-width:800px){text-align:left;font-size:1.125rem;}');
	
	var ButtonContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1gbd5pt5'
	})('display:flex;flex-wrap:wrap;align-items:center;justify-content:space-evenly;button{margin-bottom:1rem;}a{margin-bottom:1rem;}@media (min-width:800px){margin-right:2rem;}@media (min-width:1450px){justify-content:space-between;}');
	
	var anchorText = /*#__PURE__*/(0, _emotion.css)('text-decoration:underline;');
	
	var HTRImage = /*#__PURE__*/(0, _reactEmotion2.default)('img', {
	  target: 'e1gbd5pt6'
	})('width:90%;margin:2rem auto;display:block;@media (min-width:800px){margin:2rem 0rem 2rem;}');
	
	var FileIconLinkClass = /*#__PURE__*/(0, _emotion.css)('vertical-align:middle;margin-right:0.5rem;text-decoration:none;');
	
	var Hero = function Hero(props) {
	
	  return _react2.default.createElement(
	    HeroWrapper,
	    null,
	    _react2.default.createElement(
	      HeaderWrapper,
	      null,
	      props.children,
	      _react2.default.createElement(
	        'h1',
	        null,
	        props.header
	      ),
	      _react2.default.createElement(
	        HeroSubheader,
	        null,
	        props.subHeader
	      ),
	      _react2.default.createElement(
	        CTAWrapper,
	        null,
	        _react2.default.createElement(
	          ButtonContainer,
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            { to: '/schedule' },
	            'Schedule Demo'
	          ),
	          _react2.default.createElement(_RegisterButton2.default, null),
	          _react2.default.createElement(
	            _Button2.default,
	            { to: '', secondary: true, onClick: function onClick() {
	                return props.toggleVideo();
	              } },
	            'See How It Works'
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'https://hoteltechreport.com/company/whistle', target: '_blank' },
	          _react2.default.createElement(HTRImage, { src: _whistleTopRatedX2.default })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'https://whistle-ebook.paperform.co', target: '_blank', className: anchor, download: true },
	          _react2.default.createElement(
	            'i',
	            { className: FileIconLinkClass + ' material-icons' },
	            'menu_book'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: anchorText },
	            '2020 Guest Messaging e-Book'
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'https://gmpbuyersguide.paperform.co', target: '_blank', className: anchor },
	          _react2.default.createElement(
	            'i',
	            { className: FileIconLinkClass + ' material-icons' },
	            'file_copy'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: anchorText },
	            '2020 Guest Messaging Software Buyer\'s Guide'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      VectorWrapper,
	      null,
	      _react2.default.createElement(_hero_vector2.default, null)
	    )
	  );
	};
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MobilePhoneVector = function MobilePhoneVector(props) {
	    return _react2.default.createElement(
	        "svg",
	        { viewBox: "0 0 393 275", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { id: "Main_Desktop", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", transform: "translate(-149.000000, -1556.000000)" },
	            _react2.default.createElement(
	                "g",
	                { id: "How-It-Works", transform: "translate(149.000000, 1363.000000)" },
	                _react2.default.createElement(
	                    "g",
	                    { id: "Mobile_Vector", transform: "translate(0.000000, 194.000000)" },
	                    _react2.default.createElement("path", { d: "M7.35414103,215.664863 L94.9330418,267.75476 C108.370702,275.747169 125.086168,275.822104 138.594947,267.950497 L384.884678,124.436711 C392.042419,120.265873 394.463782,111.082245 390.292944,103.924504 C389.011241,101.724922 387.190806,99.8877374 385.003054,98.5859436 L295.827961,45.5234321 C282.312408,37.4811729 265.485986,37.4529481 251.943529,45.4498198 L7.39494859,189.856666 C0.261533539,194.068975 -2.10649149,203.2665 2.10581664,210.399916 C3.3857695,212.567477 5.19063852,214.378062 7.35414103,215.664863 Z", id: "Path-17-Copy-3", fillOpacity: "0.05", fill: "#000000" }),
	                    _react2.default.createElement("path", { d: "M98.1942771,219.375165 C62.4401094,199.314504 39.5034247,186.188876 29.3842231,179.998282 C17.3877676,172.659246 11.2255136,166.076485 10.8974609,160.25 L10.8974609,174.159282 C10.8974609,183.80159 16.0593687,192.70606 24.4267646,197.497802 L98.023629,239.644384 C111.275152,247.233109 127.555948,247.230371 140.804917,239.637188 L372.743731,106.709582 C378.096037,103.642096 381.397461,97.9448155 381.397461,91.775808 L381.397461,69.5 C380.612629,78.3776314 376.186671,85.1308278 368.119587,89.7595892 C360.420272,94.1773309 284.554613,137.341725 140.522611,219.252771 L140.522612,219.252772 C127.409935,226.709955 111.34986,226.756393 98.1942771,219.375165 Z", id: "Path-17-Copy", fill: "#FBBD08" }),
	                    _react2.default.createElement("path", { d: "M98.1942771,219.375165 C62.4401094,199.314504 39.5034247,186.188876 29.3842231,179.998282 C17.3877676,172.659246 11.2255136,166.076485 10.8974609,160.25 L10.8974609,174.159282 C10.8974609,183.80159 16.0593687,192.70606 24.4267646,197.497802 L98.023629,239.644384 C111.275152,247.233109 127.555948,247.230371 140.804917,239.637188 L372.743731,106.709582 C378.096037,103.642096 381.397461,97.9448155 381.397461,91.775808 L381.397461,69.5 C380.612629,78.3776314 376.186671,85.1308278 368.119587,89.7595892 C360.420272,94.1773309 284.554613,137.341725 140.522611,219.252771 L140.522612,219.252772 C127.409935,226.709955 111.34986,226.756393 98.1942771,219.375165 Z", id: "Path-17-Copy-4", fillOpacity: "0.05", fill: "#000000" }),
	                    _react2.default.createElement("path", { d: "M21.6487499,175.561378 L96.7822568,219.311298 C110.048098,227.03594 126.424421,227.108592 139.758277,219.501955 L370.467029,87.8882917 C380.788382,82.000214 384.382262,68.8598742 378.494184,58.5385213 C376.618106,55.2498994 373.907449,52.5145633 370.635965,50.6087577 L294.004846,5.96723668 C280.661643,-1.80585757 264.176384,-1.8332254 250.807445,5.89552295 L21.7069955,138.341316 C11.4196271,144.28857 7.90126953,157.449333 13.848524,167.736701 C15.7231833,170.979426 18.4119081,173.676579 21.6487499,175.561378 Z", id: "Path-17", stroke: "#FBBD08", fill: "#FFFFFF" }),
	                    _react2.default.createElement("path", { d: "M292.337563,27.8769246 L320.836167,44.2191854 C332.245998,50.7620479 346.443408,49.9480926 357.030716,42.1441064 L297.159145,8.02283105 L297.159145,8.02283105 C291.290231,8.28231344 286.742888,13.2503603 287.00237,19.1192742 C287.163321,22.7596262 289.176508,26.064247 292.337563,27.8769246 Z", id: "Path-17-Copy-2", stroke: "#FBBD08", fill: "#FFFFFF" }),
	                    _react2.default.createElement(
	                        "g",
	                        { id: "Phone_Deail", transform: "translate(36.000000, 66.000000)" },
	                        _react2.default.createElement("path", { d: "M4.44235361,91.1232007 L84.0433187,137.440919 C84.9727572,137.981735 86.1205644,137.983729 87.0518765,137.446146 L147.205433,102.723597 C148.640385,101.895297 149.132173,100.060569 148.303873,98.625618 C148.039885,98.1682826 147.659859,97.7887297 147.202195,97.5253112 L66.7397879,51.2134068 C65.8064368,50.6761961 64.6567497,50.6804733 63.7274217,51.2246138 L4.4353068,85.9413493 C3.00551388,86.7785221 2.52510031,88.6162609 3.36227305,90.0460538 C3.62348009,90.4921648 3.99553383,90.863208 4.44235361,91.1232007 Z", id: "Path-60", stroke: "#FBBD08" }),
	                        _react2.default.createElement("path", { d: "M74.7237786,50.0001705 L154.114355,96.1954691 C154.970001,96.6933473 156.01618,96.7370578 156.910376,96.3122899 L167.447835,91.3067013 C168.944417,90.5957825 169.581324,88.8062487 168.870405,87.3096658 C168.608789,86.7589267 168.185571,86.3009764 167.657133,85.9968222 L87.5339995,39.8801942 C86.6599449,39.3771129 85.5916032,39.3468589 84.6904791,39.7996697 L74.8855777,44.7265877 C73.4051229,45.4705094 72.8080449,47.2737229 73.5519666,48.7541777 C73.8133858,49.2744197 74.2205413,49.7073499 74.7237786,50.0001705 Z", id: "Path-60-Copy", stroke: "#FBBD08" }),
	                        _react2.default.createElement(
	                            "g",
	                            { id: "qwerty", transform: "translate(47.456221, 71.632906)", fill: "#D8D8D8" },
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-6", points: "8.7187635 0 0 5.00900901 8.7187635 10.018018 17.171659 5.00900901" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-7", points: "19.9583948 6.26126126 11.2396313 11.2702703 19.9583948 16.2792793 28.4112903 11.2702703" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-8", points: "31.1980262 12.5225225 22.4792627 17.5315315 31.1980262 22.5405405 39.6509217 17.5315315" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-9", points: "42.4376575 18.7837838 33.718894 23.7927928 42.4376575 28.8018018 50.890553 23.7927928" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-10", points: "53.6772888 25.045045 44.9585253 30.0540541 53.6772888 35.0630631 62.1301843 30.0540541" })
	                        ),
	                        _react2.default.createElement(
	                            "g",
	                            { id: "Qwertytop", transform: "translate(52.451613, 61.614888)", fill: "#D8D8D8" },
	                            _react2.default.createElement("polygon", { id: "Path-61", points: "8.7187635 0 0 5.00900901 8.7187635 10.018018 17.171659 5.00900901" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy", points: "19.9583948 6.26126126 11.2396313 11.2702703 19.9583948 16.2792793 28.4112903 11.2702703" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-2", points: "31.1980262 12.5225225 22.4792627 17.5315315 31.1980262 22.5405405 39.6509217 17.5315315" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-3", points: "42.4376575 18.7837838 33.718894 23.7927928 42.4376575 28.8018018 50.890553 23.7927928" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-4", points: "53.6772888 25.045045 44.9585253 30.0540541 53.6772888 35.0630631 62.1301843 30.0540541" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-5", points: "64.9169202 31.3063063 56.1981567 36.3153153 64.9169202 41.3243243 73.3698157 36.3153153" })
	                        ),
	                        _react2.default.createElement(
	                            "g",
	                            { id: "Qwertytop-Copy", transform: "translate(19.981567, 75.389663)", fill: "#D8D8D8" },
	                            _react2.default.createElement("polygon", { id: "Path-61", points: "19.9583948 0 11.2396313 5.00900901 19.9583948 10.018018 28.4112903 5.00900901" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-11", points: "8.7187635 6.26126126 0 11.2702703 8.7187635 16.2792793 17.171659 11.2702703" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-13", points: "19.9583948 12.5225225 11.2396313 17.5315315 53.2284841 42.2470043 61.6813796 37.2379953" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy", points: "31.1980262 6.26126126 22.4792627 11.2702703 31.1980262 16.2792793 39.6509217 11.2702703" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-2", points: "42.4376575 12.5225225 33.718894 17.5315315 42.4376575 22.5405405 50.890553 17.5315315" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-3", points: "53.6772888 18.7837838 44.9585253 23.7927928 53.6772888 28.8018018 62.1301843 23.7927928" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-4", points: "64.9169202 25.045045 56.1981567 30.0540541 64.9169202 35.0630631 73.3698157 30.0540541" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-5", points: "76.1565515 31.3063063 67.437788 36.3153153 76.1565515 41.3243243 84.609447 36.3153153" }),
	                            _react2.default.createElement("polygon", { id: "Path-61-Copy-12", points: "64.9169202 38.8198198 56.1981567 43.8288288 64.9169202 48.8378378 73.3698157 43.8288288" })
	                        ),
	                        _react2.default.createElement("path", { d: "M149.693356,83.4818273 L153.123496,85.2015728 L153.402747,84.6415486 L150.317864,83.0949023 L152.648487,81.650924 L158.291475,87.890173 L146.115207,85.6987316 L149.693356,83.4818273 Z", id: "Combined-Shape", fill: "#D8D8D8" }),
	                        _react2.default.createElement("path", { d: "M115.362022,30.1272864 L168.988367,61.3754912 C171.345847,62.7492005 174.26338,62.734229 176.606637,61.3363978 L196.874198,49.2461211 C198.652839,48.1851028 199.234587,45.8831044 198.173568,44.104464 C197.843139,43.5505478 197.375426,43.091221 196.815623,42.7708664 L141.029816,10.8467163 C139.059926,9.71942144 136.633732,9.74863219 134.691554,10.9230273 L128.818847,14.4741332 L122.262395,14.4741332 L122.262395,18.543953 L112.473657,24.1897934 C111.277625,24.8796279 110.86727,26.4084251 111.557105,27.6044576 C111.783395,27.996798 112.112018,28.3202935 112.507869,28.5403853 L115.362022,30.1272864 Z", id: "Path-63", fill: "#00B386" }),
	                        _react2.default.createElement("path", { d: "M186.546354,20.1092684 L240.172699,51.3574732 C242.530179,52.7311824 245.447711,52.716211 247.790969,51.3183798 L254.426417,47.3601134 L261.650785,47.3601134 L261.650785,43.0505369 L268.05853,39.2281031 C269.837171,38.1670847 270.418918,35.8650864 269.3579,34.086446 C269.02747,33.5325298 268.559758,33.073203 267.999954,32.7528484 L212.214148,0.828698252 C210.244258,-0.298596579 207.818064,-0.269385829 205.875886,0.905009284 L200.003178,4.45611521 L193.446727,8.52593503 L183.657989,14.1717754 C182.461957,14.8616099 182.051602,16.3904071 182.741437,17.5864396 C182.967726,17.97878 183.29635,18.3022755 183.692201,18.5223673 L186.546354,20.1092684 Z", id: "Path-63-Copy", fill: "#FBBD08" })
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = MobilePhoneVector;
	module.exports = exports["default"];

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _emotion = __webpack_require__(5);
	
	var _reactModalVideo = __webpack_require__(46);
	
	var _reactModalVideo2 = _interopRequireDefault(_reactModalVideo);
	
	var _section = __webpack_require__(11);
	
	var _section2 = _interopRequireDefault(_section);
	
	var _hero = __webpack_require__(284);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _Button = __webpack_require__(13);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _PartnersList = __webpack_require__(283);
	
	var _PartnersList2 = _interopRequireDefault(_PartnersList);
	
	var _FeatureList = __webpack_require__(50);
	
	var _FeatureList2 = _interopRequireDefault(_FeatureList);
	
	var _HowItWorks = __webpack_require__(51);
	
	var _HowItWorks2 = _interopRequireDefault(_HowItWorks);
	
	__webpack_require__(824);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var partnersClass = /*#__PURE__*/(0, _emotion.css)('position:relative;');
	
	var PartnersHeaderWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1y65hba0'
	})('text-align:center;');
	
	var SectionHeader = /*#__PURE__*/(0, _reactEmotion2.default)('h3', {
	  target: 'e1y65hba1'
	})('text-align:center;font-size:36px;font-weight:bold;');
	
	var PartnersButton = /*#__PURE__*/(0, _emotion.css)('@media (min-width:1025px){display:none;}');
	
	var SubH3 = /*#__PURE__*/(0, _reactEmotion2.default)('h3', {
	  target: 'e1y65hba2'
	})('font-weight:300;margin-bottom:2rem;');
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage(props) {
	    _classCallCheck(this, IndexPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      openVideo: false
	    };
	    return _this;
	  }
	
	  IndexPage.prototype.render = function render() {
	    var _this2 = this;
	
	    console.log(this.props);
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _section2.default,
	        null,
	        _react2.default.createElement(_hero2.default, {
	          header: 'Your Hotel\u2019s Digital Front Desk',
	          subHeader: _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              SubH3,
	              null,
	              'Integrated with your favorite tools, Whistle is the all-in-one to streamline front office operations.'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Automated Guest Messaging | Team Collaboration ',
	              _react2.default.createElement('br', null),
	              ' Upselling | Task Management'
	            )
	          ),
	          toggleVideo: function toggleVideo() {
	            return _this2.setState({ openVideo: true });
	          }
	        })
	      ),
	      _react2.default.createElement(
	        _section2.default,
	        { id: 'partners', light: true, className: partnersClass, animated: true },
	        _react2.default.createElement(
	          PartnersHeaderWrapper,
	          null,
	          _react2.default.createElement(
	            SectionHeader,
	            null,
	            'Integrations & Partners'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { anchor: true, secondary: true, to: '/testimonials', className: PartnersButton },
	            'Read their Stories'
	          )
	        ),
	        _react2.default.createElement(_PartnersList2.default, {
	          partners: this.props.data.allMarkdownRemark.edges
	        })
	      ),
	      _react2.default.createElement(
	        _section2.default,
	        { id: 'how-it-works', animated: true },
	        _react2.default.createElement(
	          SectionHeader,
	          null,
	          'How It Works'
	        ),
	        _react2.default.createElement(_HowItWorks2.default, {
	          toggleVideo: function toggleVideo() {
	            return _this2.setState({ openVideo: true });
	          }
	        })
	      ),
	      _react2.default.createElement(
	        _section2.default,
	        { id: 'features', light: true, animated: true },
	        _react2.default.createElement(
	          SectionHeader,
	          null,
	          'The Whistle Platform'
	        ),
	        _react2.default.createElement(_FeatureList2.default, null)
	      ),
	      _react2.default.createElement(_reactModalVideo2.default, {
	        channel: 'vimeo',
	        isOpen: this.state.openVideo,
	        videoId: '258364855',
	        onClose: function onClose() {
	          return _this2.setState({ openVideo: false });
	        }
	      })
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = IndexPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-6c3b7bec8ed96123ade9.js